import { type ReactNode } from "react";
import { type Locale } from "./locale";

/**
 * A plataforma é apenas em português. Mantemos a mesma API pública para não
 * quebrar os componentes que consomem o contexto de idioma.
 */

export function LocaleProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

export function useLocale() {
  return {
    locale: "pt" as Locale,
    setLocale: (_l: Locale) => {},
    t: (pt: string) => pt,
    marketplaceEnabled: true,
    feedEnabled: true,
  };
}

export function useMarketplaceEnabled() {
  return true;
}

export function useFeedEnabled() {
  return true;
}

export type { Locale };
